"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// To use in antd's <Upload>
// TODO: progress
// TODO: abort
var useCustomRequest = function useCustomRequest(_ref) {
  var api_requests = _ref.api_requests,
      refreshAccessToken = _ref.refreshAccessToken,
      _ref$onSuccess = _ref.onSuccess,
      _onSuccess = _ref$onSuccess === void 0 ? function () {} : _ref$onSuccess,
      _ref$onError = _ref.onError,
      _onError = _ref$onError === void 0 ? function () {} : _ref$onError,
      _ref$onProgress = _ref.onProgress,
      _onProgress = _ref$onProgress === void 0 ? function () {} : _ref$onProgress;

  var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var access_token = api_requests.access_token,
      refreshing_tokens = api_requests.refreshing_tokens;

  var _useState = (0, _react.useState)("Bearer ".concat(access_token)),
      _useState2 = _slicedToArray(_useState, 2),
      authHeader = _useState2[0],
      setAuthHeader = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      started = _useState4[0],
      setStarted = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      success = _useState6[0],
      setSuccess = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = _slicedToArray(_useState7, 2),
      file = _useState8[0],
      setFile = _useState8[1];

  var _useState9 = (0, _react.useState)({
    url: '/',
    method: 'GET',
    body: null
  }),
      _useState10 = _slicedToArray(_useState9, 2),
      params = _useState10[0],
      setParams = _useState10[1];

  var _useState11 = (0, _react.useState)(function () {
    return {
      onSuccess: function onSuccess() {},
      onError: function onError() {},
      onProgress: function onProgress() {}
    };
  }),
      _useState12 = _slicedToArray(_useState11, 2),
      callbacks = _useState12[0],
      setCallbacks = _useState12[1];

  (0, _react.useEffect)(function () {
    setAuthHeader("Bearer ".concat(access_token));

    if (started && !success) {
      launchRequest(params, file, callbacks);
    }
  }, [// eslint-disable-line react-hooks/exhaustive-deps
  access_token]);
  var launchRequest = (0, _react.useCallback)(function (_ref2, file, _ref3) {
    var url = _ref2.url,
        method = _ref2.method,
        body = _ref2.body;
    var onSuccess = _ref3.onSuccess,
        onError = _ref3.onError,
        onProgress = _ref3.onProgress;
    return fetch(url, {
      method: method,
      headers: {
        'Authorization': authHeader
      },
      body: body
    }).then(function (response) {
      if (response.ok) {
        return response.text();
      }

      if (response.status === 401) {
        if (!refreshing_tokens) {
          refreshAccessToken();
        } // if no error => we are retrying


        return Promise.reject(false);
      }

      return Promise.reject(response.statusText);
    }).then(function (data) {
      setSuccess(true);
      return onSuccess(data, file);
    }).catch(function (error) {
      // if no error => we are retrying
      if (error) {
        onError(error);
      }
    });
  }, [// eslint-disable-line react-hooks/exhaustive-deps
  authHeader]);
  var customRequest = (0, _react.useCallback)(function (_ref4) {
    var action = _ref4.action,
        data = _ref4.data,
        file = _ref4.file,
        filename = _ref4.filename,
        onFormError = _ref4.onError,
        onFormProgress = _ref4.onProgress,
        onFormSuccess = _ref4.onSuccess;
    // EXAMPLE: post form-data with 'axios'
    var formData = new FormData();

    if (data) {
      Object.keys(data).forEach(function (key) {
        formData.append(key, data[key]);
      });
    }

    formData.append(filename, file);
    var params = {
      url: "".concat(action, "?filename=").concat(encodeURIComponent((file || {}).name || filename)),
      method: 'POST',
      body: formData
    };
    var callbacks = {
      onSuccess: function onSuccess(body) {
        onFormSuccess(body);

        _onSuccess(body);
      },
      onError: function onError(error, body) {
        onFormError(error, body);

        _onError(error, body);
      },
      onProgress: function onProgress(e) {
        onFormProgress(e);

        _onProgress(e);
      }
    };
    setFile(file);
    setParams(params);
    setCallbacks(callbacks);
    setStarted(true);
    launchRequest(params, file, callbacks);
    return {
      abort: function abort(file) {
        console.log('Canceled', file);
      }
    };
  }, [launchRequest, _onError, _onProgress, _onSuccess].concat(_toConsumableArray(deps)));
  return customRequest;
};

var _default = useCustomRequest;
exports.default = _default;